/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import {hashHistory} from 'react-router'
import {Button, Table, Checkbox, Col} from 'antd';
import {DmsTab, TableView} from 'Components';
import {getZhiXiaoList} from '../../service/customerManagement';
import {detail, getAddressList, getCreditList} from '../../service/purchaseUnit';
/*购货单位详情,终端单位,信用情况接口*/
import './purchaseUnit.css';

class StoreDetail extends React.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            purchaseUnitId: parseInt(this.props.params.purchaseUnitId, 10),
            detail: {},
            address: [],
            option: [],
            /*信用情况*/
            staffs: [],
            staffTotal: 0,
            staffObj: {
                s: 10,
                p: 1,
                channelCode: this.channelData.split('|')[1] || '',
                purchaseId: this.props.params.purchaseUnitId
            },
            zhiXiao: [],
            zhiXiaoTotal: 0,
            zhiXiaoObj: {
                s: 10,
                p: 1,
                channelCode: this.channelData.split('|')[1] || '',
                purchaseId: this.props.params.purchaseUnitId,
            },
        };
        this.getDetail = this.getDetail.bind(this);
        this.getAddress = this.getAddress.bind(this);
        this.getStaffs = this.getStaffs.bind(this);
        this.staffPageChange = this.staffPageChange.bind(this);
    };

    componentDidMount() {
        this.getDetail();
        this.getAddress();
        this.getStaffs();
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*返回*/
    goBack() {
        hashHistory.goBack();
    };

    /*购货单位详情接口*/
    getDetail() {
        const self = this;
        detail(self.state.purchaseUnitId).then(res => {
            var cl = res.data.channelList,
                dms = res.data.dmsChannels;
            for (var i = 0; i < cl.length; i++) {
                for (var j = 0; j < dms.length; j++) {
                    var dmsEle = dms[j];
                    if (cl[i] === dmsEle.code) {
                        dmsEle.checked = true;
                        break;
                    }
                }
            }
            // console.dir(dms)
            self.setState({
                detail: res.data,
                option: dms
            }, () => {
                self.getZhiXiao();
            });
        })
    };

    /*终端单位-地址信息接口*/
    getAddress() {
        const self = this;
        getAddressList(self.state.purchaseUnitId).then(res => {
            self.setState({
                address: res.data,
            })
        })
    };

    /*信用情况接口*/
    getStaffs() {
        const self = this;
        const {staffObj} = this.state;
        getCreditList(staffObj).then(res => {
            self.setState({
                staffs: res.data.data,
                staffTotal: res.data.total
            })
        })
    };

    /*信用情况翻页*/
    staffPageChange(page, pageSize) {
        const self = this;
        this.setState({staffObj: {...this.state.staffObj, s: pageSize, p: page}}, function () {
            self.getStaffs();
        });
    };

    /*直销授信接口*/
    getZhiXiao() {
        const self = this;
        // const  zhiXiaoObj  = {...self.state.zhiXiaoObj};
        // zhiXiaoObj.customerId = self.state.detail.thirdId;
        getZhiXiaoList(self.state.zhiXiaoObj).then(res => {
            if (res && res.status == true) {
                self.setState({
                    zhiXiao: res.data,
                    zhiXiaoTotal: res.total
                })
            }
        })
    };

    /*指销售信翻页*/
    zhiXiaoChange(page, pageSize) {
        const self = this;
        this.setState({zhiXiaoObj: {...this.state.zhiXiaoObj, s: pageSize, p: page}}, function () {
            self.getZhiXiao();
        });
    };

    render() {
        const {detail, address, staffs, option, staffTotal, staffObj, zhiXiao, zhiXiaoTotal, zhiXiaoObj} = this.state;
        const addressProps = {
            rowKey: 'id',
            columns: [
                {
                    title: '编号',
                    dataIndex: 'id',
                },
                {
                    title: '项目信息（含终端）',
                    dataIndex: 'projectMsg',
                },
                {
                    title: '所属片区',
                    dataIndex: 'areaName',
                },
                {
                    title: '所属省份',
                    dataIndex: 'regionName',
                },
                {
                    title: '销售人员',
                    dataIndex: 'sellerName',
                },
                {
                    title: '联系人',
                    dataIndex: 'linkman',
                },
                {
                    title: '联系方式',
                    dataIndex: 'contactWay',
                },
                {
                    title: '实际收货地址',
                    dataIndex: 'address',
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                },
            ],
            dataSource: address
        };
        const staffProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: staffTotal,
                current: staffObj.p,//当前页码
                pageSize: staffObj.s,//当前分页数
                onChange: this.staffPageChange
            },
            columns: [
                {
                    title: '授信方式',
                    dataIndex: 'pay',
                },
                {
                    title: '渠道',
                    dataIndex: 'channelName',
                },
                {
                    title: '授信项目或购货单位',
                    dataIndex: 'projectName',
                },
                {
                    title: '授信额度',
                    dataIndex: 'sxeAmount',
                },
                {
                    title: '折扣池余额',
                    dataIndex: 'discountAmount',
                },

                {
                    title: '折扣可折余额',
                    dataIndex: 'discountKzAmount',
                },
                {
                    title: '已用额度',
                    dataIndex: 'yyAmount',
                },
                {
                    title: '可用额度',
                    dataIndex: 'kyAmount',
                },

            ],
            rows: staffs,
        };
        const zhixiaoProps = {
            loading: false,//更新表格数据中
            rowKey: 'lineId',
            pageParam: {
                total: zhiXiaoTotal,
                current: zhiXiaoObj.p,//当前页码
                pageSize: zhiXiaoObj.s,//当前分页数
                onChange: this.zhiXiaoChange
            },
            columns: [
                // {
                //   title: '授信方式',
                //   dataIndex: 'pay',
                // },
                {
                    title: '变动日期',
                    dataIndex: 'creationDate',
                    render: (text) => text ? new Date(text).format('yyyy-MM-dd') : ''
                },
                {
                    title: '项目编号',
                    dataIndex: 'projectNumber',
                },
                {
                    title: '项目名称',
                    dataIndex: 'projectName',
                },

                {
                    title: '购货单位',
                    dataIndex: 'purchaseName',
                },
                {
                    title: '可用余额',
                    dataIndex: 'kyAmount',
                },
                /*        {
                          title: '是否折扣',
                          dataIndex: 'descountFlag',
                          render: (text) => text == 'Y' ? <div>{'是'}</div> : <div>{'否'}</div>
                        },*/
                {
                    title: '质保金',
                    dataIndex: 'zbjMoney',
                },
                {
                    title: '质保金到期时间',
                    dataIndex: 'zbjDate',
                },
                {
                    title: '开始时间',
                    dataIndex: 'startDate',
                    render: (text) => text ? new Date(text).format('yyyy-MM-dd') : ''
                },
                {
                    title: '结束时间',
                    dataIndex: 'endDate',
                    render: (text) => text ? new Date(text).format('yyyy-MM-dd') : ''
                },

            ],
            rows: zhiXiao,
        };


        return <div className="dms-main-box">
            <div>
                <DmsTab options={[`购货单位详情 -- ${detail.name || ''}`]} defaultKey={0}>
                    <Button onClick={this.goBack}>返回</Button>
                </DmsTab>
                <DmsTab className="white-bg no-border" options={['基本属性']} defaultKey={0}/>
                <div className="dms-table-box" style={{padding: '0'}}>
                    <div className="purchaseUnit_detail">
                        <div className="infor">
                            <a>
                                <p><label>ID</label><span>{detail.id}</span></p>
                                <p><label>编号</label><span>{detail.code}</span></p>
                                <p><label>购货单位</label><span>{detail.name}</span></p>
                                <p><label>法人代表</label><span>{detail.corporateRepresentative}</span></p>
                                <p><label>签约类型</label><span>{detail.contractType}</span></p>
                            </a>
                            <a>
                                <p><label>客户类型</label><span>{detail.cusType}</span></p>
                                <p><label>销售模式</label><span>{detail.saleType}</span></p>
                                <p><label>业务所属行业</label><span>{detail.businessIndustry}</span></p>
                                <p><label>单位联系人</label><span>{detail.linkman}</span></p>
                                <p><label>明细小数位</label><span>{detail.decimalPlace}</span></p>
                            </a>
                            <a>
                                <p><label>地址</label><span>{detail.address}</span></p>
                                <p><label>电话</label><span>{detail.tel}</span></p>
                                <p><label>是否启用</label><span>{detail.status}</span></p>
                                <p><label>职务</label><span>{detail.roleName}</span></p>
                                <p><label>汇总小数位</label><span>{detail.summaryDecimal}</span></p>
                            </a>
                            <p>开单权限：
                                <span><Checkbox checked={detail.ordinaryOrderFlag == 'Y' ? true : false}
                                                disabled={true}/><span>常规订单权限</span></span>
                                <span><Checkbox checked={detail.terminalOrderFlag == 'Y' ? true : false}
                                                disabled={true}/><span>项目订单权限</span></span>
                                <span><Checkbox checked={detail.vipOrderFlag == 'Y' ? true : false}
                                                disabled={true}/><span>合作伙伴订单权限</span></span>
                            </p>
                            <p>总部提货：
                                <span><Checkbox checked={detail.headquartersTake == 'Y' ? true : false}
                                                disabled={true}/><span>总部提货</span></span>
                            </p>
                        </div>
                    </div>
                </div>
                <DmsTab className="white-bg no-border" options={['销售渠道']} defaultKey={0}/>
                <Col className="channel_detail">
                    {(option || []).map(function (ele, ind) {
                        return <Checkbox checked={ele.checked} key={ind + ''} value={ele.name}
                                         disabled>{ele.name}</Checkbox>
                    })}
                </Col>
                <DmsTab className="white-bg no-border" options={['购货单位-财务管理']} defaultKey={0}/>
                <div className="dms-table-box" style={{padding: '0'}}>
                    <div className="purchaseUnit_detail">
                        <div className="infor">
                            <a>
                                <p><label>开票发票类型</label><span>{detail.invoiceType}</span></p>
                                <p><label>地址</label><span>{detail.invoiceAddress}</span></p>
                                <p><label>折扣比例</label><span>{detail.discount}</span></p>
                                <p><Checkbox checked={detail.taxpayerFlag == 'Y' ? true : false}
                                             disabled={true}/><span>一般纳税人</span></p>
                                <p><Checkbox checked={detail.debtHold == 'Y' ? true : false}
                                             disabled={true}/><span>账款暂挂</span></p>
                            </a>
                            <a>
                                <p><label>账号</label><span>{detail.account}</span></p>
                                <p><label>纳税人标识号</label><span>{detail.taxpayerCode}</span></p>
                                <p><label>开户行</label><span>{detail.openingBank}</span></p>
                                <p><Checkbox checked={detail.holdFlag == 'Y' ? true : false}
                                             disabled={true}/><span>暂挂</span></p>
                                <p><Checkbox checked={detail.accountHold == 'Y' ? true : false}
                                             disabled={true}/><span>对账暂挂</span></p>
                            </a>
                            <a>
                                <p><label>发票开具时间</label><span>{detail.invoiceTime}</span></p>
                                <p><label>电话</label><span>{detail.invoicePhone}</span></p>
                                <p style={{color: '#fafafa'}}>1</p>
                                <p><Checkbox checked={detail.discountFlag == 'Y' ? true : false}
                                             disabled={true}/><span>折扣单位</span></p>
                                <p><Checkbox checked={detail.otherHold == 'Y' ? true : false}
                                             disabled={true}/><span>其他暂挂</span></p>
                            </a>
                        </div>
                    </div>
                </div>
                <DmsTab className="white-bg no-border" options={['购货单位-法务管理']} defaultKey={0}/>
                <div className="dms-table-box">
                    <div style={{height: '40px'}}>
                        <p style={{paddingLeft: 10, float: 'left'}}>
                            <label>付款条件：</label><span>{detail.payment || '-'}</span></p>
                        <p style={{paddingLeft: 40, float: 'left'}}>
                            <label>信用等级：</label><span>{detail.creditLevel || '-'}</span></p>
                        <p style={{paddingLeft: 40, float: 'left'}}><span>直营不需要项目：</span><Checkbox
                            checked={detail.noprojectFlag == 'Y' ? true : false} disabled={true}/></p>
                    </div>
                </div>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['终端单位-地址信息']} defaultKey={0}>
                </DmsTab>
                <div className="dms-table-box">
                    <Table {...addressProps} bordered pagination={false}/>
                </div>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['信用情况']} defaultKey={0}>
                </DmsTab>
                <div className="dms-table-box">
                    <TableView {...staffProps}/>
                </div>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['直销授信']} defaultKey={0}>
                </DmsTab>
                <div className="dms-table-box">
                    <TableView {...zhixiaoProps} />
                </div>
            </div>
        </div>
    }
}
;
export default StoreDetail;


// WEBPACK FOOTER //
// ./src/routes/purchaseUnit/detail.js